import { createFileRoute } from '@tanstack/react-router';
import { useDashboardContext } from './dashboard-context';
import { ComplaintsDashboard } from './sections/Complaints';
import { ComplaintsV2Dashboard } from './sections/ComplaintsV2';

export const Route = createFileRoute('/console/$orgId/dashboard/complaints')({
    component: RouteComponent,
});

function RouteComponent() {
    const { dashboards, refetchSignal, showComplaintsV2 } = useDashboardContext();

    return showComplaintsV2 ? (
        <ComplaintsV2Dashboard />
    ) : (
        <ComplaintsDashboard
            key={refetchSignal.complaints}
            setFilters={dashboards.setFilters.complaints}
            loading={dashboards.loading.complaintsDashboard}
            data={dashboards.data.complaintsDashboard}
        />
    );
}
